import { useRecoilValue } from "recoil";
import Banner from "../../components/Banner";
import { errorPageState } from "../../store/layout";

const ErrorPage: React.FC = () => {
	const errorComponent = useRecoilValue(errorPageState);

	return <Banner>{errorComponent}</Banner>;
};

export default ErrorPage;
